import React from 'react';

import { type RouteComponentProps } from 'react-router-dom';

import { AnalyticsKeys, TrackPageLoad } from '@atlassian/ptc-common';

import KudosPage from '../components/KudosPage/lazy';
import { type ProfileData } from '../components/ProfileKudos/lazy';
import RecordTransition from '../components/RecordTransition';

interface KudosMatchParams {
	uuid: string;
}

function hasProfileProp(state?: unknown): state is { profile: ProfileData } {
	return !!state && 'profile' in (state as any);
}

const KudosPageRoute = ({ match, location }: RouteComponentProps<KudosMatchParams>) => {
	const { uuid } = match.params;

	const profile = hasProfileProp(location.state) ? location.state.profile : undefined;

	return (
		<>
			<RecordTransition name={AnalyticsKeys.KUDOS_PAGE_VIEW} />
			<TrackPageLoad name={AnalyticsKeys.KUDOS_PAGE_VIEW} />
			<KudosPage uuid={uuid} referrerProfile={profile} />
		</>
	);
};

export default KudosPageRoute;
